export default __webpack_public_path__ + "static/media/Picture-African-business.a78279d4.png";